<template>
  <v-row>
    <v-col cols="12">
      <b-input
        v-model="form.topic"
        :error-messages="getErrorMessages(v$.topic)"
        label="Назва"
        placeholder="Коротко сформулюйте завдання"
        @blur="v$.topic.$touch()"></b-input>
      <b-textarea
        v-model="form.description"
        :error-messages="getErrorMessages(v$.description)"
        label="Опис"
        placeholder="Опишіть що потрібно виконати"
        rows="4"
        @blur="v$.description.$touch()"></b-textarea>
    </v-col>

    <v-col class="pt-0" cols="12" md="6">
      <b-server-autocomplete
        v-model="form.executorId"
        :error-messages="getErrorMessages(v$.executorId)"
        :url="urlAllUsers()"
        item-title="name"
        item-value="id"
        label="Виконавець"
        placeholder="Введіть мін. 3 символи"
        @blur="v$.executorId.$touch()"></b-server-autocomplete>
    </v-col>

    <v-col class="pt-0" cols="12" md="6">
      <b-input-date
        v-model="form.deadline"
        :error-messages="getErrorMessages(v$.deadline)"
        :min-date="new Date()"
        label="Дедлайн"
        time-picker
        @blur="v$.deadline.$touch()"></b-input-date>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { reactive } from 'vue'
import {
  BInput,
  BInputDate,
  BServerAutocomplete,
  BTextarea,
} from 'best-modules/components'
import { CustomDate, getErrorMessages } from 'best-modules/utils'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import type { Dialog } from '@/dialog'
import { urlAllUsers } from '@/utils/urls'
import { taskCreate } from '@/requests/task'
import { setSnackbar } from 'best-modules/plugins'
import { ENTITY_TYPE } from '@/utils/constants'
import type { IncidentIssue } from '@/utils/types/incident'
import type { TaskCredentials } from '@/utils/types/task'

defineOptions({
  name: 'IncidentIssueTask',
})

const INCIDENT_ISSUE_TASK_TYPE_ID = 6

const props = defineProps<{
  dialog: Dialog<{ issue: IncidentIssue }>
}>()

const issue = props.dialog.dialogData.issue
const form = reactive<{
  topic: string | null
  description: string | null
  executorId: number | null
  deadline: string | null
}>({
  topic: issue.topic || null,
  description: issue.description || null,
  executorId: null,
  deadline: null,
})

const rules = {
  topic: { required },
  description: { required },
  executorId: { required },
  deadline: { required },
}

const v$ = useVuelidate(rules, form)

const submit = () => {
  return taskCreate({
    typeId: INCIDENT_ISSUE_TASK_TYPE_ID,
    topic: form.topic || '',
    description: form.description || '',
    executorId: Number(form.executorId),
    isHighImportance: true,
    deadline:
      new CustomDate(form.deadline).toString({
        format: 'iso',
        time: true,
      }) || '',
    entityId: issue.id,
    entityTypeId: ENTITY_TYPE.INCIDENT_ISSUE,
    attachment: [],
    contractorId: null,
    observers: [],
    controlUsers: [],
    isCEO: false,
  } as TaskCredentials).then(task => {
    setSnackbar({
      color: 'success',
      text: 'Завдання створено',
    })

    return task
  })
}

defineExpose({
  submit,
  v$,
})
</script>
